import React from 'react';
import { Sun, Moon } from 'lucide-react';

const ThemeToggle = ({ mode, setMode }) => {
  return (
    <button
      type="button"
      onClick={() => setMode(mode === 'light' ? 'dark' : 'light')}
      className="p-2.5 rounded-full bg-white/80 dark:bg-slate-900/80 backdrop-blur-md border border-slate-200/50 dark:border-slate-800/50 text-slate-700 dark:text-slate-200 shadow-sm hover:bg-slate-50 dark:hover:bg-slate-800 transition-all duration-300 flex items-center justify-center focus:outline-none"
      aria-label="Toggle Dark Mode"
    >
      {mode === 'light' ? (
        <Moon className="w-5 h-5 text-slate-700" />
      ) : (
        <Sun className="w-5 h-5 text-amber-400" />
      )}
    </button>
  );
};

export default ThemeToggle;
